import { BaseResponse } from "./claimDetails.models";

export class FileDetailRequest {
    filepath : string;
}

export class FileDetailResponse extends BaseResponse {
    isSuccess: boolean
    fileURL : string;
}